(function () {
  const animationTimers = new WeakMap();

  const stopAnimation = (element) => {
    const timer = animationTimers.get(element);
    if (timer) window.clearTimeout(timer);
    animationTimers.delete(element);
    element.style.transition = "none";
    element.style.overflow = "hidden";
  };

  const finishAnimation = (element, hidden) => {
    element.style.display = hidden ? "none" : "block";
    element.style.removeProperty("height");
    element.style.removeProperty("overflow");
    element.style.removeProperty("transition");
    animationTimers.delete(element);
  };

  const slideUp = (element, duration) => {
    if (!element || window.getComputedStyle(element).display === "none") return;
    stopAnimation(element);
    element.style.height = `${element.getBoundingClientRect().height}px`;
    void element.offsetHeight;
    element.style.transition = `height ${duration}ms ease`;
    element.style.height = "0px";
    animationTimers.set(
      element,
      window.setTimeout(() => finishAnimation(element, true), duration),
    );
  };

  const slideDown = (element, duration) => {
    if (!element) return;
    stopAnimation(element);
    element.style.display = "block";
    element.style.height = "0px";
    void element.offsetHeight;
    const targetHeight = element.scrollHeight;
    element.style.transition = `height ${duration}ms ease`;
    element.style.height = `${targetHeight}px`;
    animationTimers.set(
      element,
      window.setTimeout(() => finishAnimation(element, false), duration),
    );
  };

  const initProductAccordion = () => {
    document.querySelectorAll(".about__accordion-toggle").forEach((toggle) => {
      if (toggle.dataset.iigAccordionBound === "true") return;
      toggle.dataset.iigAccordionBound = "true";

      toggle.addEventListener("click", function () {
        const description =
          toggle.parentElement?.querySelector(":scope > .about__accordion-description") || null;
        if (!toggle.classList.contains("active")) {
          toggle.classList.add("active");
          slideDown(description, 300);
        } else {
          toggle.classList.remove("active");
          slideUp(description, 300);
        }
      });
    });
  };

  const initZoomImage = () => {
    const imagesWrapper = document.querySelector(
      ".product-media-modal__content"
    );
    const images = imagesWrapper.querySelectorAll(".js-image-zoom");

    images.forEach((el) => {
      el.addEventListener("click", (e) => {
        imagesWrapper.classList.toggle("zoom");
      });
    });
  };

  const revealPopup = () => {
    const stickyBar = document.querySelector(".product__popup"); // Sticky bar
    const secondSection = document.querySelector(".product-section + section"); // Second section
    const secondShopifySection = document.querySelector(".product-section + .shopify-section"); // Second shopify section
    const footer = document.querySelector("footer"); // Footer

    // Check if the required elements exist
    if (!stickyBar || !(secondSection || secondShopifySection) || !footer) {
      console.error("Required elements not found!");
      return;
    }

    const getOffset = (element) => {
      const rect = element.getBoundingClientRect();
      return rect.top + window.scrollY;
    };

    const secondSectionMid = getOffset(secondSection || secondShopifySection);
    const footerTop = getOffset(footer);

    const handleScroll = () => {
      const scrollPosition = window.scrollY + window.innerHeight;
      const activeOffset =
        window.scrollY > secondSectionMid && scrollPosition < footerTop;

      stickyBar.classList[activeOffset ? "add" : "remove"]("active");
    };

    // Initial check in case the user starts in the middle of the page
    handleScroll();
  };

  document.addEventListener("scroll", () => revealPopup());

  document.addEventListener("shopify:section:load", function () {
    initProductAccordion();
    initZoomImage();
    revealPopup();
  });

  initProductAccordion();
  initZoomImage();
  revealPopup();

  const syncPairedQuantity = (event) => {
    const input = event.target;
    if (!input.classList?.contains("quantity__input")) return;

    const match = input.id.match(/^Quantity-(?:(floated)-)?(.+)$/);
    if (!match) return;

    const pairedId = match[1]
      ? `Quantity-${match[2]}`
      : `Quantity-floated-${match[2]}`;
    const pairedInput = document.getElementById(pairedId);
    if (!pairedInput || pairedInput.value === input.value) return;

    pairedInput.value = input.value;
    pairedInput.closest("quantity-input")?.setMinimumDisable();
  };

  document.addEventListener("change", syncPairedQuantity);
})();

class FloatedForm extends HTMLElement {
  constructor() {
    super();
    this.renderForm();
  }

  renderForm() {
    fetch(this.getAttribute("data-product-url"))
      .then((response) => response.text())
      .then((responseText) => {
        const responseHTML = new DOMParser().parseFromString(
          responseText,
          "text/html"
        );
        this.productElement = responseHTML.querySelector(
          'div[id^="ProductInfo-"]'
        );

        this.preventDuplicatedIDs();
        this.removeDOMElements();
        this.setInnerHTML(this, this.productElement.innerHTML);

        if (window.Shopify && Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }

        if (window.ProductModel) window.ProductModel.loadShopifyXR();

        this.showMoreFields();
      });
  }

  setInnerHTML(element, html) {
    element.innerHTML = html;

    // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
    element.querySelectorAll("script").forEach((oldScriptTag) => {
      const newScriptTag = document.createElement("script");
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }

  preventDuplicatedIDs() {
    const sectionId = this.productElement.dataset.section;
    this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(
      sectionId,
      `floated-${sectionId}`
    );

    if (this.productElement.querySelectorAll("variant-selects")) {
      this.productElement
        .querySelectorAll("variant-selects")
        .forEach((radio) => {
          radio.dataset.originalSection = sectionId;
        });
    }

    if (this.productElement.querySelectorAll("variant-radios")) {
      this.productElement
        .querySelectorAll("variant-radios")
        .forEach((radio) => {
          radio.dataset.originalSection = sectionId;
        });
    }
  }

  removeDOMElements() {
    const text = this.productElement.querySelector(".product__text");
    if (text) text.remove();

    const tags = this.productElement.querySelector(".product__tags");
    if (tags) tags.remove();

    const title = this.productElement.querySelector(".product__title__wrapper");
    if (title) title.remove();

    const badges = this.productElement.querySelector(".product__custom-badges");
    if (badges) badges.remove();

    const price = this.productElement.querySelector(".price-wrapper");
    if (price) price.remove();

    const description = this.productElement.querySelector(
      ".product__description"
    );
    if (description) description.remove();

    const sku = this.productElement.querySelector(".product__sku");
    if (sku) sku.remove();

    const inventory = this.productElement.querySelector(".product__inventory");
    if (inventory) inventory.remove();

		this.productElement
			.querySelectorAll(".custom-info-block")
			.forEach((infoBlock) => infoBlock.remove());

    const pickupAvailability = this.productElement.querySelector(
      "pickup-availability"
    );
    if (pickupAvailability) pickupAvailability.remove();

    const customLiquid = this.productElement.querySelector(".custom-liquid");
    if (customLiquid) customLiquid.remove();

    const complementary = this.productElement.querySelector(
      "product-recommendations"
    );
    if (complementary) complementary.remove();

    const shareButtons = this.productElement.querySelector(".share-buttons");
    if (shareButtons) shareButtons.remove();

    const productModal = this.productElement.querySelectorAll(".product-popup");
    productModal.forEach((advantage) => {
      advantage.remove();
    });

    const productForm = this.productElement.querySelector("floated-form");
    if (productForm) productForm.remove();
  }

  showMoreFields() {
    this.querySelectorAll(".js-show-more").forEach((trigger) => {
      if (trigger.dataset.iigShowMoreBound === "true") return;
      trigger.dataset.iigShowMoreBound = "true";
      trigger.addEventListener("click", (event) => {
        event.preventDefault();
        trigger.parentElement
          ?.querySelectorAll(":scope > input, :scope > label")
          .forEach((element) => element.classList.remove("hidden"));
        trigger.remove();
      });
    });
  }
}

customElements.define("floated-form", FloatedForm);
